<ng-container [ngSwitch]="mode">
    <ng-container *ngSwitchCase="EditorModes.EDITING">
        <ng-container [ngTemplateOutlet]="selectedGroup ? noteEntry : templateIsBasicNote ? baseNote : null"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="EditorModes.REVIEWING">
        <div *ngIf="syncingNote" class="p-d-flex p-ai-center p-jc-center">
            <p-message severity="info" text="Loading Note Preview"></p-message>
        </div>
        <lb-note *ngIf="!syncingNote && note" [note]="note" viewStyle="CARD" applyStyles="tagsOnly"></lb-note>
    </ng-container>
</ng-container>

<ng-template #baseNote>
    <lb-text-editor id="basicNote"
                    #basicNote
                    lb-events (afterViewInit)="focus(basicNote)"
                    [model]="noteModel"
                    [useRichText]="useRichText"
                    [height]="5"
                    (modelChanged)="onBasicNoteUpdate($event)">
    </lb-text-editor>
</ng-template>

<ng-template #noteEntry>
    <div class="p-fluid">
        <p-card *ngFor="let control of selectedControls; let isFirst = first" [ngSwitch]="control.templateSegmentType"
                [styleClass]="((isFirst ? '' : 'p-mt-2 ') + 'p-shadow-3 entry-card')">
            <div class="p-field p-grid" [ngClass]="control.templateSegmentType !== SegmentTypes.LITERAL_TEXT ? 'p-mb-2' : ''">
                <div *ngIf="control.templateSegmentType !== SegmentTypes.LITERAL_TEXT" class="p-col-12">
                    <div class="p-d-flex p-jc-between overflow-menu-container">
                            <label class="whitespace-pre-line" [for]="getSegmentHTMLId(control.templateSegment)">
                                <span *ngIf="control.templateSegment.key" title="Key Field" class="fa fa-key p-mr-1"></span>
                                {{control.templateSegment.name}}
                                <span class="required">{{(control.templateSegment.required) ? '*' : ''}}</span>
                                {{getRangeText(control.templateSegment)}}
                            </label>
                        <span class="pi pi-ellipsis-v clickable" (click)="menu.show($event)"></span>
                    </div>
                    <p-menu #menu [model]="overflowMenu[control.templateSegmentId]" [popup]="true" appendTo="body"></p-menu>
                </div>

                <div [ngClass]="{ 'p-col-12': !control.templateSegment.calculate, 'p-col-11': control.templateSegment.calculate }">
                    <div [ngSwitch]="control.templateSegmentType">
                        <ng-container *ngSwitchCase="SegmentTypes.CHECKBOX">
                            <p-triStateCheckbox [disabled]="control.templateSegment.calculate!"
                                                lb-events (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"
                                                [inputId]="getSegmentHTMLId(control.templateSegment)"
                                                [(ngModel)]="control.value">
                            </p-triStateCheckbox>
                        </ng-container>

                        <ng-container *ngSwitchCase="SegmentTypes.TEXT_INPUT">
                            <lb-text-editor *ngIf="!control.templateSegment.calculate!"
                                            #textEditor lb-events (afterViewInit)="focus(textEditor)"
                                            [name]="control.templateSegment.longName"
                                            (modelChanged)="control.extras.useRichText = $event.useRichText; control.value = $event.text"
                                            [model]="control.value"
											[showRichTextToggle]="control.templateSegment.textOption ?
												['ALLOW_RICH_TEXT', 'DEFAULT_TO_RICH_TEXT'].includes(control.templateSegment.textOption) :
												!!control.templateSegment.height"
                                            [useRichText]="!!control.extras.useRichText"
                                            [width]="control.templateSegment.width"
                                            [height]="control.templateSegment.height">
                            </lb-text-editor>

                            <textarea *ngIf="control.templateSegment.calculate!"
                                      pInputTextarea
                                      [disabled]="true"
                                      [ngModel]="control.value"
                                      [style]="{ width: control.templateSegment.width, height: control.templateSegment.height }">
                            </textarea>
                        </ng-container>

                        <div *ngSwitchCase="SegmentTypes.LITERAL_TEXT" [innerText]="control.templateSegment.text"></div>

                        <ng-container *ngSwitchCase="SegmentTypes.NUMERIC_INPUT">
                            <div *ngIf="control.templateSegment.units; else numericInput" class="input-number-group p-inputgroup">
                                <ng-container *ngTemplateOutlet="numericInput"></ng-container>
                                <span class="p-inputgroup-addon">{{control.templateSegment.units}}</span>
                            </div>

                            <ng-template #numericInput>
                                <input [id]="getSegmentHTMLId(control.templateSegment)"
                                       [disabled]="control.templateSegment.calculate!"
                                       lb-events (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"
                                       pInputText
                                       [(ngModel)]="control.value"
                                       [attr.name]="control.templateSegment.longName"
                                       autocomplete="on"
                                       class="numeric-input"
                                       type="number">
                            </ng-template>

                        </ng-container>

                        <ng-container *ngSwitchCase="SegmentTypes.USER_CHOOSER">
                            <logbook-user-selector (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"
                                                   [inputId]="getSegmentHTMLId(control.templateSegment)"
                                                   [logId]="control.logId"
                                                   [(ngModel)]="control.value">
                            </logbook-user-selector>
                        </ng-container>

                        <div *ngSwitchCase="SegmentTypes.TEXT_CHOICE">
                            <choicelist-item-selector *ngIf="!control.templateSegment.calculate!"
                                                      (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"
                                                      [inputId]="getSegmentHTMLId(control.templateSegment)"
                                                      [listId]="control.templateSegment.choiceList!.id"
                                                      [(ngModel)]="control.value"
                                                      (ngModelChange)="noteEntryService.addValueToChoiceListValueMap(control.templateSegment.choiceList!.id, control.value)">
                            </choicelist-item-selector>
                            <input pInputText
                                   *ngIf="control.templateSegment.calculate!"
                                   [disabled]="true"
                                   [ngModel]="control.value ? control.value.value : ''">
                        </div>

                        <ng-container *ngSwitchCase="SegmentTypes.TAG_CHOICE">
                            <tag-selector *ngIf="!control.templateSegment.calculate"
                                          (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"
                                          [inputId]="getSegmentHTMLId(control.templateSegment)"
                                          [logId]="control.logId"
                                          [parentTagId]="control.templateSegment.tagValue?.id"
                                          [depth]="control.templateSegment.depth"
                                          [(ngModel)]="control.value">
                            </tag-selector>
                            <p-chips *ngIf="control.templateSegment.calculate!" [disabled]="true" [ngModel]="control.value"></p-chips>
                        </ng-container>

                        <ng-container *ngSwitchCase="SegmentTypes.DATE_TIME">
                            <p-message *ngIf="getCalendarControl(calendar, control).isInvalid"
                                       severity="warn"
                                       text="The current date is invalid">
                            </p-message>
                            <p-calendar #calendar
                                        [inputId]="getSegmentHTMLId(control.templateSegment)"
                                        [disabled]="control.templateSegment.calculate!"
                                        lb-events (afterViewInit)="focus(getSegmentHTMLId(control.templateSegment))"

                                        [showTime]="!!control.templateSegment.includeTime"
                                        [timeOnly]="!control.templateSegment.includeDate && !!control.templateSegment.includeTime"
                                        [monthNavigator]="true"
                                        [yearNavigator]="true"
                                        [selectOtherMonths]="true"
                                        [hideOnDateTimeSelect]="false"
                                        [showIcon]="true"
                                        [keepInvalid]="true"

                                        [touchUI]="mobileView"
                                        [readonlyInput]="false"
                                        [showOnFocus]="false"

                                        [formControl]="getCalendarControl(calendar, control).control"

                                        yearRange="1900:2100"
                                        hourFormat="24"
                                        appendTo="body">
                                <ng-template pTemplate="header">
                                    <div class="p-grid p-nogutter">
                                        <div class="p-col-3 p-pl-2 p-d-flex p-ai-center">
                                            <label *ngIf="mobileView">{{control.templateSegment.name}}</label>
                                        </div>
                                        <div class="p-col-3 p-offset-6 p-text-right">
                                            <button pButton class="btn-standard p-button-secondary p-button-rounded p-button-text"
                                                    icon="pi pi-times"
                                                    (click)="calendar.hideOverlay()">
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <div class="p-grid">
                                        <div class="p-col-6 p-pb-0">
                                            <button class="w-100" pButton label="Now"
                                                    (click)="setCalendarValue(calendar, control, 'now')">
                                            </button>
                                        </div>
                                        <div class="p-col-6 p-pb-0">
                                            <button class="w-100" pButton label="Clear"
                                                    (click)="setCalendarValue(calendar, control, null)">
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-calendar>
                        </ng-container>

                        <ng-container *ngSwitchCase="SegmentTypes.FILE_ATTACHMENT">
                            <lb-file-uploader #fileUploader lb-events (afterViewInit)="focus(fileUploader)"
                                              [disabled]="control.templateSegment.calculate!"
                                              [(ngModel)]="control.value"
                                              [fileLimit]="control.templateSegment.maxAllowed">
                            </lb-file-uploader>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="control.templateSegment.calculate" class="p-col-1 p-grid p-jc-center p-ai-center">
                    <span class="fa fa-calculator calculation-indicator"
                          (click)="showCalcOverlay($event, control)"
                          [ngClass]="!getToolTip(control.templateSegmentId) ? 'completed' : ''"
                          pTooltip="{{getToolTip(control.templateSegmentId)}}">
                    </span>
                </div>

                <div class="p-col-12">
                    <p-message *ngIf="control.errorMessage"
                               styleClass="p-mt-1"
                               [severity]="control.errorMessage!.severity"
                               [text]="control.errorMessage!.text">
                    </p-message>
                    <p-message *ngIf="calculationErrors[control.templateSegmentId]"
                               styleClass="p-mt-1"
                               severity="error"
                               text="Calculation Error: {{calculationErrors[control.templateSegmentId]}}">
                    </p-message>
                </div>

                <div class="p-col-12 p-mt-1">
                    <p-panel styleClass="comment-panel p-mt-2" *ngIf="control.displayingComments">
                        <ng-template pTemplate="header">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                <label>Comments</label>
                                <div [ngClass]="{'comment-chip': true, 'gone': !control.commentError}">
                                    <p-chip>Required</p-chip>
                                </div>
                            </div>
                        </ng-template>
                        <lb-note-comment [noteEntryInput]="control"></lb-note-comment>
                    </p-panel>
                    <div class="p-mt-1" *ngIf="control.displayingPastValues && note">
                        <lb-past-values [segment]="control.templateSegment" [note]="note"></lb-past-values>
                    </div>
                </div>

            </div>
        </p-card>
    </div>
</ng-template>
<p-confirmDialog key="invalidDateDialog"
                 appendTo="body"
                 header="Invalid Date"
                 [closable]="false"
></p-confirmDialog>
<p-dialog appendTo="body"
          header="Calculations"
          [style]="{ width: '750px' }"
          [(visible)]="calcDialogVisible"
          [focusTrap]="true"
          [draggable]="true"
          [modal]="true"
          [dismissableMask]="true">
    {{mobileOverlayText}}
</p-dialog>